import { render } from "./PermissionView.vue?vue&type=template&id=ce3359f4&scoped=true"
import script from "./PermissionView.vue?vue&type=script&lang=js"
export * from "./PermissionView.vue?vue&type=script&lang=js"

import "./PermissionView.vue?vue&type=style&index=0&id=ce3359f4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3359f4"]])

export default __exports__